import { LicenseException } from '@/domain/licensing/exception/LicenseException'

export class UserNotFoundException extends LicenseException
{

}
